import React, { Component } from "react";
import './App.css';
import AppHost from './Components/AppHost'
import TrackAppHost from './Components/TrackAppHost'
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Dialog from './Components/Dialog';


export default class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isBlocking: false,
      showDialog: false,
      dialogTitle: '',
      dialogActions: <></>,
      dialogContent: <></>,
      fullScreen: false,
      enableClose: false,
      showOk: false
    }
  }

  handleCloseDialog = () => {
    this.setState({ showDialog: false })
  }

  setDialogState = (show, title, content, actions, fullScreen = false, enableClose = false, showOk = false) => {

    this.setState({
      showDialog: show,
      dialogTitle: title,
      dialogActions: actions,
      dialogContent: content,
      fullScreen: fullScreen,
      enableClose: enableClose,
      showOk: showOk
    })
  }

  render() {
    let basePath=''
    if (window.location.pathname.includes('/pages/track')) {
      basePath = '/pages/track'
    }
    else {
      basePath = '/pages/returns'
    }
    return (
      <div>
        <Dialog
          //transition={Transition}
          open={this.state.showDialog}
          title={this.state.dialogTitle}
          actions={this.state.dialogActions}
          fullScreen={this.state.fullScreen}
          handleClose={this.handleCloseDialog}
          enableClose={this.state.enableClose}
          showOk={this.state.showOk}
        >

          <Grid container direction="column" justify="center" alignItems="center" spacing={0}>
            {this.state.dialogContent}
          </Grid>

        </Dialog>
        <Box style={{ margin: 5, padding: 10, border: "1px solid black", borderRadius: 4 }} elevation={1}>
          {basePath.includes('/pages/track') ?
            <TrackAppHost basePath={basePath} setDialogState={this.setDialogState} />
            :
            <AppHost basePath={basePath} setDialogState={this.setDialogState} />
          }
        </Box>
      </div>
    )

  }
}


